/* eslint-disable id-length */
const NIL = require("../../node_modules/uuid/dist/nil")
const v4 = require("../../node_modules/uuid/dist/v4")
const validate = require("../../node_modules/uuid/dist/validate")

module.exports = {
  NIL: NIL?.default || NIL,
  v4: v4?.default || v4,
  validate: validate?.default || validate,
}
